import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { FaRegEye, FaTimes } from "react-icons/fa";
import url from "../../function/url";
import EmployeeNavbar from "../Employees/EmployeeNavbar";
import "../company/formstyle.css";
import Swal from "sweetalert2";
import "./work.css";
import ReactPaginate from "react-paginate"; // Import pagination

const Worklist = () => {
  const [worklist, setWorklist] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // State for search results
  const [modalDescription, setModalDescription] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const ID = Cookies.get("log_id");

  useEffect(() => {
    const fetchWorklist = async () => {
      if (!ID) {
        Swal.fire("Error", "Login ID not found. Please log in again.", "error");
        return;
      }
      try {
        const response = await axios.get(`${url.path}/my-worklist/${ID}/`);
        if (response.data.status) {
          setWorklist(response.data.worklist);
          setFilteredData(response.data.worklist); // Set initial filtered data
        } else {
          Swal.fire("Error", response.data.message, "error");
        }
      } catch (error) {
        console.error("Error fetching worklist:", error);
        Swal.fire(
          "Error",
          error.response?.data?.message || "Failed to fetch worklist. Try again later.",
          "error"
        );
      }
    };
    fetchWorklist();
  }, [ID]);

  const handleShowModal = (description) => {
    setModalDescription(description);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalDescription("");
  };

  // Search function to filter data
  const searchTable = (event) => {
    const searchValue = event.target.value.trim().toLowerCase();
    const filtered = worklist.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(searchValue)
      )
    );
    setFilteredData(filtered);
    setCurrentPage(0); // Reset to first page after search
  };

  // Paginated Data
  const offset = currentPage * itemsPerPage;
  const currentItems = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <>
      <EmployeeNavbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Work List
        </h3>
      </center>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          onChange={searchTable}
          className="search-input"
          id="search"
        />
      </div>

      <div className="table-container">
        {filteredData.length > 0 ? (
          <>
            <table className="responsive-table" id="companytable">
              <thead>
                <tr>
                  <th>Work Name</th>
                  <th>Assigned Date</th>
                  <th>Due Date</th>
                  <th>Status</th>
                  <th>Description</th>
                  <th>Document</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item) => (
                  <tr key={item.id}>
                    <td data-label="Work Name">{item.work_name}</td>
                    <td data-label="Assigned Date">{item.assigned_date}</td>
                    <td data-label="Due Date">{item.due_date}</td>
                    <td data-label="Status">{item.status}</td>
                    <td data-label="Description">
                      {item.work_description && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <FaRegEye
                            className="description-icon"
                            onClick={() => handleShowModal(item.work_description)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      )}
                    </td>
                    <td data-label="Document">
                      {item.Document && (
                        <a
                          href={`${url.path}${item.Document}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ReactPaginate
  previousLabel={"← Previous"}
  nextLabel={"Next →"}
  breakLabel={"..."}
  pageCount={pageCount}
  marginPagesDisplayed={2}
  pageRangeDisplayed={3}
  onPageChange={handlePageClick}
  containerClassName={"pagination"}
  pageClassName={"page-item"}
  pageLinkClassName={"page-link"}
  previousClassName={"page-item"}
  previousLinkClassName={"page-link"}
  nextClassName={"page-item"}
  nextLinkClassName={"page-link"}
  breakClassName={"page-item"}
  breakLinkClassName={"page-link"}
  activeClassName={"active"}
  disabledClassName={"disabled"}
/>

          </>
        ) : (
          <p>No worklist available.</p>
        )}

        {/* Modal for Description */}
        {showModal && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>Description</h2>
                <FaTimes className="close-icon" onClick={handleCloseModal} />
              </div>
              <p>{modalDescription}</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Worklist;
